import React, { useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import "./index.css";

function FormInput(props) {
  const { control } = useFormContext();
  const { name, label, required, errorobj, type } = props;

  // Estado para mostrar/ocultar contraseña
  const [showPassword, setShowPassword] = useState(false);

  let isError = false;
  let errorMessage = "";
  if (errorobj && errorobj.hasOwnProperty(name)) {
    isError = true;
    errorMessage = errorobj[name].message;
  }

  // Función para alternar visibilidad de contraseña
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Determinar el tipo de input
  const inputType = type === 'password' && showPassword ? 'text' : type;

return (
  <Controller
    control={control}
    name={name}
    defaultValue=""
    render={(renderProps) => (
      <TextField
        {...renderProps}
        {...props}
        type={inputType}
        variant="outlined"
        label={label}
        fullWidth={true}
        InputLabelProps={{
          className: required ? "required-label" : "",
          required: required || false,
        }}
        InputProps={{
          ...props.InputProps,
          endAdornment: type === 'password' ? (
            <InputAdornment
              position="end"
              style={{
                marginRight: 4,
                backgroundColor: 'transparent',
                height: '100%',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <IconButton
                onClick={handleTogglePasswordVisibility}
                edge="end"
                aria-label="toggle password visibility"
                className="password-toggle-button"
                size="small"
                disableRipple
                disableFocusRipple
                style={{
                  backgroundColor: 'transparent',
                  color: '#666',
                  padding: '6px',
                  margin: 0,
                  minWidth: 'auto',
                  width: 'auto',
                  height: 'auto'
                }}
              >
                {showPassword ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
              </IconButton>
            </InputAdornment>
          ) : props.InputProps?.endAdornment,
        }}
        error={isError}
        helperText={errorMessage}
      />
    )}
  />
)
}

export default FormInput;
